export const translations = {
  en: {
    'Email': 'Email',
    'Work telephone number': 'Work telephone number',
    'Cell telephone number': 'Cell telephone number',
    'WhatsApp': 'WhatsApp',
    'Facebook Messenger': 'Facebook Messenger',
    'Google Business Message': 'Google Business Message',
    'Website': 'Website',
    'Working time': 'Working time'
  },
  de: {
    'Email': 'E-Mail',
    'Work telephone number': 'Geschäftliche Telefonnummer',
    'Cell telephone number': 'Mobiltelefonnummer',
    'WhatsApp': 'WhatsApp',
    'Facebook Messenger': 'Facebook Messenger',
    'Google Business Message': 'Google Business Message',
    'Website': 'Webseite',
    'Working time': 'Öffnungszeiten'
  },
  fr: {
    'Email': 'E-mail',
    'Work telephone number': 'Numéro de téléphone professionnel',
    'Cell telephone number': 'Numéro de téléphone portable',
    'WhatsApp': 'WhatsApp',
    'Facebook Messenger': 'Facebook Messenger',
    'Google Business Message': 'Google Business Message',
    'Website': 'Site web',
    'Working time': "Horaires d'ouverture"
  },
  es: {
    'Email': 'Correo electrónico',
    'Work telephone number': 'Número de teléfono de trabajo',
    'Cell telephone number': 'Número de teléfono móvil',
    'WhatsApp': 'WhatsApp',
    'Facebook Messenger': 'Facebook Messenger',
    'Google Business Message': 'Google Business Message',
    'Website': 'Sitio web',
    'Working time': 'Horario de apertura'
  }
};

export const getTranslatedLabel = (key: string): string => {
  const locale = navigator.language.slice(0, 2) as keyof typeof translations;
  const fallbackLocale = 'en' as keyof typeof translations;
  
  return translations[locale]?.[key as keyof typeof translations[typeof locale]] || 
         translations[fallbackLocale][key as keyof typeof translations[typeof fallbackLocale]] || 
         key;
};

export const getProtocolUrl = (type: string, value: string): string => {
  switch (type) {
    case 'Email':
      return `mailto:${value}`;
    case 'Work telephone number':
    case 'Cell telephone number':
      // RFC 3966: tel:-URIs erlauben "-" "." "()" als Trennzeichen, aber
      // kein Leerzeichen. Nur das Linkziel bereinigen, der sichtbare Text
      // (displayValue) bleibt davon unberuehrt.
      return `tel:${value.replace(/\s+/g, '')}`;
    case 'WhatsApp': {
      const phoneNumber = value.includes('phone=') 
        ? value.split('phone=')[1]?.split('&')[0] || ''
        : value.replace(/\D/g, '');
      return `https://wa.me/${phoneNumber}`;
    }
    case 'Facebook Messenger':
      return value.startsWith('http') ? value : `https://m.me/${value}`;
    case 'Google Business Message':
      return value.startsWith('http') ? value : `https://${value}`;
    case 'Website':
      return value.startsWith('http') ? value : `https://${value}`;
    default:
      return value;
  }
};